export enum EBalconyType {
  Balcony = 'balcony',
  Loggia = 'loggia',
}
